export const containerWidth = '700px';
export const largeContainerWidth = '800px';